import { Navigate, useParams } from "react-router-dom";

/**
 * Phase 1: forwards to the existing rich Device Detail page. The mock's
 * full custom layout (hero card, facts grid, action grid, checklist, timeline)
 * is wired in phase 2 once we re-use the existing detail data hooks under
 * a mobile-only shell.
 */
export default function MobileDeviceDetailPage() {
  const { id } = useParams<{ id: string }>();
  if (!id) return <Navigate to="/m/devices" replace />;
  return <Navigate to={`/devices/${id}`} replace />;
}
